import { Navbar, Footer } from "@/components/site-chrome";
import { LiveBusMap } from "@/components/live-bus-map";
import { Reveal } from "@/components/landing/editorial-backgrounds";
import {
  SectionLabel,
  CREAM, CHARCOAL, WINE, FONT_SANS, FONT_DISPLAY,
} from "@/components/landing/editorial-backgrounds";

const VERMILION = "#E8371A";
const LINE = "#E2E7E3";
const GRAIN = `url("data:image/svg+xml,%3Csvg viewBox='0 0 200 200' xmlns='http://www.w3.org/2000/svg'%3E%3Cfilter id='noise'%3E%3CfeTurbulence type='fractalNoise' baseFrequency='0.9' numOctaves='4' stitchTiles='stitch'/%3E%3C/filter%3E%3Crect width='100%25' height='100%25' filter='url(%23noise)'/%3E%3C/svg%3E")`;

export function TransportPage() {
  return (
    <div className="relative min-h-screen overflow-hidden" style={{ background: CREAM, fontFamily: FONT_SANS }}>
      <div className="pointer-events-none absolute inset-0 opacity-[0.035]" style={{ backgroundImage: GRAIN, backgroundSize: "200px 200px" }} />
      <div className="pointer-events-none absolute inset-0 opacity-50" style={{ backgroundImage: `radial-gradient(circle, ${CHARCOAL}0A 1px, transparent 1px)`, backgroundSize: "32px 32px" }} />
      <div className="absolute top-0 left-0 right-0 h-[3px]" style={{ background: `linear-gradient(90deg, ${WINE}, ${CHARCOAL}40, ${WINE})` }} />

      <div className="relative z-10">
        <Navbar />
        <section className="relative px-4 pb-16 pt-28 sm:px-8 sm:pt-40 sm:pb-32">
          <div className="relative mx-auto max-w-6xl">
            <SectionLabel label="Transport" />
            <Reveal delay={0.1}>
              <h2 className="mt-6 max-w-3xl sm:mt-8" style={{ fontFamily: FONT_DISPLAY, color: CHARCOAL, lineHeight: 0.95, letterSpacing: "-0.03em", fontSize: "clamp(1.75rem, 8vw, 5rem)", fontWeight: 700 }}>
                Every bus. Every route.
              </h2>
              <p style={{ fontFamily: FONT_DISPLAY, color: VERMILION, lineHeight: 0.95, letterSpacing: "-0.03em", fontSize: "clamp(1.75rem, 8vw, 5rem)", fontWeight: 700, fontStyle: "italic" }}>
                Every child. Tracked.
              </p>
            </Reveal>
            <Reveal delay={0.2}>
              <p className="mt-4 max-w-xl text-sm leading-[1.6] sm:mt-6 sm:text-lg sm:leading-[1.7]" style={{ fontFamily: FONT_DISPLAY, fontStyle: "italic", color: `${CHARCOAL}70` }}>
                GPS-tracked routes with live traffic, student boarding verification, driver scoring, and AI route optimization. Parents see ETAs. Schools see compliance. Children see safety.
              </p>
            </Reveal>
            <Reveal delay={0.3}>
              <div className="mt-10 overflow-hidden sm:mt-14" style={{ border: `1px solid ${LINE}`, borderRadius: 12, boxShadow: "0 1px 2px rgba(12,51,32,0.06)" }}>
                <LiveBusMap wialon autoTick height={400} title="Fleet Command Center" canViewTrails canViewHistory maxBuses={10} />
              </div>
            </Reveal>
          </div>
        </section>
        <Footer />
      </div>
    </div>
  );
}
